import type {
  GetSubscriptionResponse,
  PlanFeatures,
} from '@otter-ai/recall-client';

export const OtterPlanType = {
  REWARD: 'reward',
  FREE: 'free',
  PREMIUM: 'premium',
  TEAM: 'team',
  FREE_TEAM: 'team_free',
  FREE_TEAM_PRO: 'team_free_pro',
  ENTERPRISE: 'enterprise',
  PREMIUM_TRIAL: 'premium_trial',
} as const;
export type OtterPlanType = (typeof OtterPlanType)[keyof typeof OtterPlanType];

export const OtterPlanDiscountType = {
  ACADEMIC: 'academic',
  REGULAR: 'regular',
  EDUCATION: 'education',
  NONPROFIT: 'nonprofit',
} as const;
export type OtterPlanDiscountType =
  (typeof OtterPlanDiscountType)[keyof typeof OtterPlanDiscountType];

export const PlanPaymentPeriod = {
  YEAR: 'year',
  MONTH: 'month',
} as const;
export type PlanPaymentPeriod =
  (typeof PlanPaymentPeriod)[keyof typeof PlanPaymentPeriod];

// TODO(OTWEB-8676): Define the constants below in `api-spec`.
export const PaymentPlatform = {
  PAYMENT_CREDIT_CARD: 'credit_card',
  PAYMENT_APPLE_IN_APP_PURCHASE: 'apple_iap',
  PAYMENT_GOOGLE_IN_APP_PURCHASE: 'google_iap',
  PAYMENT_COUPON: 'coupon',
  PAYMENT_FREE: 'free',
  PAYMENT_REWARD: 'reward',
} as const;
export type PaymentPlatform =
  (typeof PaymentPlatform)[keyof typeof PaymentPlatform];

export type OtterFeatures = keyof PlanFeatures;

export const TrialType = {
  CC_PRO_WS_TRIAL: 'cc_pro_ws_trial',
  CC_TEAM_WS_TRIAL: 'cc_team_ws_trial',
  NP_PRO_WS_TRIAL: 'np_pro_ws_trial',
} as const;

export type SubscriptionPlanInfo =
  GetSubscriptionResponse['subscription']['plan'];
